import React from 'react';

import IconType from '../../../types/Icon';

const TransactionIcon: React.FC<IconType> = ({ color = 'currentColor', size = 24 }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M12 2C8.46988 2 5.37511 3.83386 3.5957 6.5957L2 5V10H7L5.05469 8.05469C6.42999 5.63616 9.01934 4 12 4C16.418 4 20 7.582 20 12C20 16.418 16.418 20 12 20C11.404 20 10.8113 19.9347 10.2363 19.8047L9.79688 21.7559C10.5159 21.9179 11.257 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2ZM11.7129 6V7.07812C11.3739 7.12113 9.47656 7.47758 9.47656 9.76758C9.47656 13.1086 12.9355 12.1206 12.9355 14.3496C12.9355 15.4656 12.2134 15.4922 12.0664 15.4922C11.9324 15.4922 11.0527 15.5635 11.0527 13.8555H9.16211C9.16211 16.7475 11.2603 16.9765 11.5723 17.0195V18H12.5742V17.0195C12.9122 16.9775 14.8242 16.6639 14.8242 14.3359C14.8242 11.1299 11.3662 11.7433 11.3652 9.77734C11.3652 8.65034 11.9851 8.61523 12.1191 8.61523C12.3641 8.61523 12.9473 8.83012 12.9473 10.2031H14.8379C14.8379 7.57613 13.0417 7.16647 12.7207 7.10547V6H11.7129ZM2 12L2.00195 12.1582C2.01295 12.9002 2.1063 13.6395 2.2793 14.3555L4.22461 13.8887C4.08561 13.3157 4.01095 12.722 4.00195 12.127L4 12H2ZM4.82812 15.5527L3.03711 16.4434C3.36711 17.1044 3.77028 17.7326 4.23828 18.3066L5.78906 17.0449C5.41506 16.5849 5.09212 16.0827 4.82812 15.5527ZM7.05469 18.2891L5.81641 19.8594C6.39941 20.3184 7.03222 20.7132 7.69922 21.0312L8.56055 19.2266C8.02655 18.9716 7.52069 18.6561 7.05469 18.2891Z"
				fill={color}
			/>
		</svg>
	);
};

export default TransactionIcon;
